"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes;
(function (PropTypes) {
    PropTypes.anything = function () { return null; };
})(PropTypes = exports.PropTypes || (exports.PropTypes = {}));
